import React, { useEffect, useState } from 'react';
import '../scss/Home.scss';
import { config } from '../../../config';
import { StaticHeader, StaticFooter } from '../components';

const FeatureRequest = () => {
  const [title, setTitle] = useState('');
  const [email, setEmail] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const body = {
        title,
        email,
        description,
      };

      const response = await fetch(config.API_URI + '/v1/feature-request', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle validation errors
        if (data.details && data.details.length > 0) {
          const errorMessages = data.details.map(detail => detail.msg).join(', ');
          setError(errorMessages);
        } else {
          setError(data.error || 'Failed to submit feature request. Please try again.');
        }
        setLoading(false);
        return;
      }

      setIsSubmitted(true);
      setTitle('');
      setEmail('');
      setDescription('');
    } catch (error) {
      console.error('Error submitting feature request:', error);
      setError('Failed to send feature request. Please try again or email us directly at zoobbe.inc@gmail.com');
    }

    setLoading(false);
  };



  return (
    <div className="landing-page">
      <StaticHeader />

      <section className="features" style={{ paddingTop: '8rem' }}>
        <div className="container">
          <div className="section-header">
            <h2>Feature Request</h2>
            <p>Have an idea to make Zoobbe better? We'd love to hear it!</p>
          </div>

          <div className="contact-form-wrapper">
            {isSubmitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h3>Thank you for your suggestion!</h3>
                <p>We've received your feature request and will review it carefully.</p>
                <button
                  onClick={() => setIsSubmitted(false)}
                  className="hero__signup-btn"
                  style={{ marginTop: '1rem' }}
                >
                  Submit Another Request
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                {error && (
                  <div className="error-message">
                    {error}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="title">Feature Title</label>
                  <input
                    type="text"
                    id="title"
                    placeholder="What feature would you like to see?"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                    disabled={loading}
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Your Email</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="your@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="description">Feature Description</label>
                  <textarea
                    id="description"
                    placeholder="Describe the feature, how it would work, and why it would be useful..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    rows={7}
                    disabled={loading}
                    className="form-input form-textarea"
                  />
                </div>

                <button
                  type="submit"
                  className="hero__signup-btn submit-btn"
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit Feature Request'}
                </button>

                {/* <p className="form-note">
                  Or email us at <a href="mailto:zoobbe.inc@gmail.com">zoobbe.inc@gmail.com</a>
                </p> */}
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Footer */}
      <StaticFooter />
    </div>
  );
};

export default FeatureRequest;